var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMapMarker = function SvgMapMarker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "48.76px",
    height: "60.95px",
    viewBox: "0 0 48.76 60.95",
    enableBackground: "new 0 0 48.76 60.95",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1825",
    transform: "translate(-3431.155 296.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2740",
    fill: "#CA0928",
    d: "M3479.9-272.56c-0.28-13.62-9.96-22.79-21.32-24.19v-0.01c-0.59-0.07-1.18-0.12-1.78-0.15 l-0.16-0.01c-0.37-0.02-0.73-0.03-1.11-0.03s-0.74,0.01-1.11,0.03l-0.16,0.01c-0.6,0.03-1.19,0.08-1.78,0.15v0.01 c-11.36,1.4-21.03,10.56-21.32,24.19h-0.01v0.61c0,10.12,8.13,22.1,24.38,35.96c16.24-13.87,24.37-25.85,24.38-35.96L3479.9-272.56 L3479.9-272.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    fill: "#FFFFFF",
    cx: 3455.53,
    cy: -272.56,
    r: 6.09
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map-marker.7b37b480.svg";
export { ForwardRef as ReactComponent };